import { downloadDocFromComment } from "@/api/comments/downloadDocFromComment";
import { useMutation } from "@tanstack/react-query"

export const useDownloadDocFromComment = () => {

  return useMutation({
    mutationKey: ['downloadDocFromComment'],
    mutationFn: downloadDocFromComment,
    retry: 1,
    onError: (error) => {
      console.error('Error downloading document:', error);
    }
  });
}
